import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    currentPrice: 0,
    userInfo: null,
    schoolInfo: null,
    KB: '', // 课表
    cateList: [], // 分类列表
    courseList: [], // 今日课表
    postItemIndex: 0,
    stuid: 0,
    sch_info: {
      about_us: '系统问题，软件bug反馈添加开发人员微信：502055',
      feedback: '系统问题，软件bug反馈添加开发人员微信：502055',
      loginFail: 'https://mp.weixin.qq.com/s?__biz=MzU5NDkwNjkzNA==&mid=100000007&idx=1&sn=021c2d0d47b02ccb2210491eb9c7345b&chksm=7e7b5b5e490cd24840fb609aea5aee49b972e6998499645be3caa0467d68a7149c06c0dcf7e2#rd',
      agreement: 'https://mp.weixin.qq.com/s?__biz=MzU5NDkwNjkzNA==&mid=100000010&idx=1&sn=0ccdcac67fa745a0c50345372a5c0d82&chksm=7e7b5b53490cd24509a671afbe6bddcaadc8fe368bfdc8d07a8ba9848e7c630cade2c4430c25#rd'
    },
    postItemName: '',
    schoolName: '请先绑定学校',
    schoolLogo: 'https://www.wechat.jiaowushu.com/school.png',
    week: '0', // 当前周
    studentName: '未登陆',
    headimgurl: 'https://www.wechat.jiaowushu.com/error_head.jpg', // 头像
    showSelectWeek: false,
    schooljwcID: '',
    account: '', // 账号
    secret: '',
    my_user_id: '',
    hasBindingSchool: false // 是否绑定学校
  },
  mutations: {
    setCurrentPrice(state, price) {
      state.currentPrice = price;
    },
    editSchoolInfo(state, schoolInfo) {
      state.schoolInfo = schoolInfo
    },
    editUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    editWeek(state, week) {
      state.week = week
      week === 0 && state.hasBindingSchool === true ? state.showSelectWeek = true : state.showSelectWeek = false
    },
    editpushcourse(state, pushcourse) {
      state.pushcourse = pushcourse
    },
    showSelectWeek(state, showSelectWeek) {
      state.showSelectWeek = showSelectWeek
    },
    changePostItem(state, item) {
      state.postItemIndex = item.postItemIndex
      state.postItemName = item.postItemName
    },
    editTermYear(state, queryInfo) {
      state.termyear = queryInfo.termyear
      state.term = queryInfo.term
    },
    // 存入课表
    editKB(state, KB) {
      state.KB = KB
    },
    // 存入今日课表
    editCourseList(state, courseList) {
      state.courseList = courseList
    },
    // 存入栏目
    editCateList(state, cateList) {
      state.cateList = cateList
    }
  },
  getters: {
    getTodayWeek(state) {
      return '第' + state.schoolInfo.week + '周'
    }
  }
})

export default store
